<script setup lang="ts">
import { computed } from 'vue'

const { selectedSemester, availableSemesters, isLoading, selectSemester } = useMetadata()

// Convert semesters to select options.
const semesterOptions = computed(() =>
  availableSemesters.value.map((semester) => ({
    label: semester.nameDE, // Using German short name as default display
    value: semester.id,
    semester,
  })),
)

// Current selected value for the Select component
const selectedValue = computed({
  get: () => selectedSemester.value?.id || null,
  set: (value: number | null) => {
    if (value) {
      const semester = availableSemesters.value.find((s) => s.id === value)
      if (semester) {
        selectSemester(semester)
      }
    }
  },
})
</script>

<template>
  <AppSelect
    v-model="selectedValue"
    :options="semesterOptions"
    option-label="label"
    option-value="value"
    :filter="false"
    :loading="isLoading"
    :disabled="isLoading || availableSemesters.length === 0"
    placeholder="Select semester..."
    class="w-26 md:w-34 pointer-coarse:h-10"
    size="small"
  />
</template>
